export enum BenefitType {
  HOTEL = 'Hébergement',
  ACTIVITY = 'Activité',
  VOL = 'Vol',
  VEHICLE = 'Location de voiture',
  VEHICLE_WITH_CHAUFFEUR = 'Véhicule avec chauffeur',
  MEAL = 'Repas',
  TRANSFER = 'Transfert',
}

export const BENEFIT_TYPES: BenefitType[] = [
  BenefitType.ACTIVITY,
  BenefitType.HOTEL,
  BenefitType.VEHICLE,
  BenefitType.VEHICLE_WITH_CHAUFFEUR,
  BenefitType.MEAL,
  BenefitType.TRANSFER,
  BenefitType.VOL,
];
